const TOKEN_KEY = 'srkAdminToken';
const ADMIN_KEY = 'srkAdminInfo';

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const getAdmin = () => {
  const raw = localStorage.getItem(ADMIN_KEY);
  return raw ? JSON.parse(raw) : null;
};

export const setSession = (token, admin) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(ADMIN_KEY, JSON.stringify(admin));
};

export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ADMIN_KEY);
};

export const AUTH_LOGOUT_EVENT = 'srk-auth-logout';

export const broadcastLogout = () => {
  window.dispatchEvent(new Event(AUTH_LOGOUT_EVENT));
};
